import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'
import { useSettingsContext } from '@eversports/react-app-base/SettingsContext'

import CalendarIcon from '../../../../../assets/icons/calendar.svg'
import { formatDate } from '../../../../../helpers/format-date'

interface Props {
  date: string
}

const ParticipationDate = ({ date }: Props) => {
  const { language } = useSettingsContext()
  const formattedDate = formatDate(language, date)
  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <Icon src={CalendarIcon} color="midnight" size="small" />
      <Text sx={{ color: 'midnight' }}>{formattedDate}</Text>
    </Stack>
  )
}

export default ParticipationDate
